export var RasterTileType;

(function (RasterTileType) {
  RasterTileType["IMAGE"] = "image";
  RasterTileType["ARRAYBUFFER"] = "arraybuffer";
})(RasterTileType || (RasterTileType = {}));
//# sourceMappingURL=interface.js.map